import { createFileRoute } from "@tanstack/react-router";
import PressureWasherGuide from "@/pages/PressureWasherGuide";

export const Route = createFileRoute("/best-pressure-washers-uk")({
  component: PressureWasherGuide,
});
